export const QUERY_KEYS = {
  billing: {
    all: ['billing'] as const,
    id: (id: string) => [...QUERY_KEYS.billing.all, 'id', id] as const,
    list: (filters?: unknown) => [...QUERY_KEYS.billing.all, 'list', filters] as const,
    summary: [...['billing'], 'summary'] as const,
  },
  bookings: {
    all: ['bookings'] as const,
    list: (filters?: unknown) => [...QUERY_KEYS.bookings.all, 'list', filters] as const,
    infinite: (filters?: unknown) => [...QUERY_KEYS.bookings.all, 'infinite', filters] as const,
  },
  category: {
    all: ['category'] as const,
    type: (kind: string) => [...QUERY_KEYS.category.all, kind] as const,
    id: (kind: string, id: string) => [...QUERY_KEYS.category.type(kind), 'id', id] as const,
    list: (kind: string, filters?: unknown) =>
      [...QUERY_KEYS.category.type(kind), 'list', filters] as const,
    infinite: (kind: string, filters?: unknown) =>
      [...QUERY_KEYS.category.type(kind), 'infinite', filters] as const,
  },
  communication: {
    all: ['communication'] as const,
    emailTemplates: {
      all: [...['communication'], 'email-templates'] as const,
      infinite: (filters?: unknown) =>
        [...['communication'], 'email-templates', 'infinite', filters] as const,
      id: (id: string) => [...['communication'], 'email-templates', 'id', id] as const,
    },
    smsTemplates: {
      all: [...['communication'], 'sms-templates'] as const,
      infinite: (filters?: unknown) =>
        [...['communication'], 'sms-templates', 'infinite', filters] as const,
      id: (id: string) => [...['communication'], 'sms-templates', 'id', id] as const,
    },
  },
  companies: {
    all: ['companies'] as const,
    id: (id: string) => [...QUERY_KEYS.companies.all, 'id', id] as const,
    infinite: (filters?: unknown) => [...QUERY_KEYS.companies.all, 'infinite', filters] as const,
    list: (filters?: unknown) => [...QUERY_KEYS.companies.all, filters] as const,
  },
  customers: {
    all: ['customers'] as const,
    id: (id: string) => [...QUERY_KEYS.customers.all, 'id', id] as const,
    infinite: (filters?: unknown) => [...QUERY_KEYS.customers.all, 'infinite', filters] as const,
    list: (filters?: unknown) => [...QUERY_KEYS.customers.all, filters] as const,
  },
  dailyNote: {
    all: ['daily-notes'] as const,
    list: (filters?: unknown) => [...QUERY_KEYS.dailyNote.all, 'getDailyNotes', filters] as const,
  },
  dashboard: {
    all: ['dashboard'] as const,
    kpis: (params: unknown) => [...QUERY_KEYS.dashboard.all, 'kpis', params] as const,
    lowInventory: (params: unknown) =>
      [...QUERY_KEYS.dashboard.all, 'lowInventory', params] as const,
  },
  employees: {
    all: ['employees'] as const,
    id: (param: string) => [...QUERY_KEYS.employees.all, 'id', param] as const,
    fromUserID: (orgID: string, userID: string) =>
      [...QUERY_KEYS.employees.all, 'fromUserID', orgID, userID] as const,
    infinite: (filters?: unknown) => [...QUERY_KEYS.employees.all, 'infinite', filters] as const,
    list: (filters?: unknown) => [...QUERY_KEYS.employees.all, 'list', filters] as const,
  },
  jobs: {
    all: ['jobs'] as const,
    id: (id: string) => [...QUERY_KEYS.jobs.all, 'id', id] as const,
    list: (filters?: unknown) => [...QUERY_KEYS.jobs.all, 'list', filters] as const,
  },
  leaves: {
    all: ['leaves'] as const,
    id: (id: string) => [...QUERY_KEYS.leaves.all, 'id', id] as const,
    list: (filters?: unknown) => [...QUERY_KEYS.leaves.all, 'list', filters] as const,
    balance: (employeeId: string) => [...QUERY_KEYS.leaves.all, 'balance', employeeId] as const,
  },
  permissions: {
    all: ['permissions'] as const,
    id: (param: string) => [...QUERY_KEYS.permissions.all, 'id', param] as const,
    list: (filters?: unknown) => [...QUERY_KEYS.permissions.all, 'list', filters] as const,
  },
  qualifications: {
    all: ['qualifications'] as const,
    list: (filters?: unknown) => [...QUERY_KEYS.qualifications.all, 'list', filters] as const,
    globalID: (orgID: string, globalQualID: string) =>
      [...QUERY_KEYS.qualifications.all, 'global', orgID, globalQualID] as const,
    localID: (storeID: string, localQualID: string) =>
      [...QUERY_KEYS.qualifications.all, 'local', storeID, localQualID] as const,
  },
  rentCar: {
    all: ['rent-car'] as const,
    available: (filters?: unknown) => [...QUERY_KEYS.rentCar.all, 'available', filters] as const,
    historyInfinite: (filters?: unknown) =>
      [...QUERY_KEYS.rentCar.all, 'history', 'infinite', filters] as const,
    infinite: (filters?: unknown) => [...QUERY_KEYS.rentCar.all, 'infinite', filters] as const,
    regNumber: (regNumber: string) => [...QUERY_KEYS.rentCar.all, 'regNumber', regNumber] as const,
  },
  roles: {
    all: ['roles'] as const,
    id: (param: string) => [...QUERY_KEYS.roles.all, 'id', param] as const,
    list: (filters?: unknown) => [...QUERY_KEYS.roles.all, 'list', filters] as const,
    map: (filters?: unknown) => [...QUERY_KEYS.roles.all, 'map', filters] as const,
  },
  rolesToPermissions: {
    all: ['rolesToPermissions'] as const,
    id: (param: string) => [...QUERY_KEYS.rolesToPermissions.all, 'id', param] as const,
  },
  products: {
    all: ['products'] as const,
    id: (id: string) => [...QUERY_KEYS.products.all, 'id', id] as const,
    infinite: (filters?: unknown) => [...QUERY_KEYS.products.all, 'infinite', filters] as const,
    list: (filters?: unknown) => [...QUERY_KEYS.products.all, 'list', filters] as const,
  },
  services: {
    all: ['services'] as const,
    id: (param: string) => [...QUERY_KEYS.services.all, 'id', param] as const,
    infinite: (filters?: unknown) => [...QUERY_KEYS.services.all, 'infinite', filters] as const,
    list: (filters?: unknown) => [...QUERY_KEYS.services.all, 'list', filters] as const,
  },
  stores: {
    all: ['stores'] as const,
    id: (param: string) => [...QUERY_KEYS.stores.all, 'id', param] as const,
    infinite: (filters?: unknown) => [...QUERY_KEYS.stores.all, 'infinite', filters] as const,
    list: (filters?: unknown) => [...QUERY_KEYS.stores.all, 'list', filters] as const,
  },
  vehicles: {
    all: ['vehicles'] as const,
    id: (id: string) => [...QUERY_KEYS.vehicles.all, 'id', id] as const,
    infinite: (filters?: unknown) => [...QUERY_KEYS.vehicles.all, 'infinite', filters] as const,
    list: (filters?: unknown) => [...QUERY_KEYS.vehicles.all, 'list', filters] as const,
    map: (filters?: unknown) => [...QUERY_KEYS.vehicles.all, 'map', filters] as const,
    regNumber: (regNumber: string) => [...QUERY_KEYS.vehicles.all, 'regNumber', regNumber] as const,
  },
  weeklyNotes: {
    all: ['weeklyNotes'] as const,
    list: (filters?: unknown) => [...QUERY_KEYS.weeklyNotes.all, 'list', filters] as const,
    id: (param: string) => [...QUERY_KEYS.weeklyNotes.all, 'id', param] as const,
  },
  workLogs: {
    all: ['work-logs'] as const,
    id: (id: string) => [...QUERY_KEYS.workLogs.all, 'id', id] as const,
    list: (filters?: unknown) => [...QUERY_KEYS.workLogs.all, 'list', filters] as const,
    todaySummary: [...['work-logs'], 'today-summary'] as const,
  },
  account: {
    all: ['account'] as const,
    profile: (userID: string) => [...['account'], 'profile', userID] as const,
    loginHistory: (userID: string) => [...['account'], 'login-history', userID] as const,
  },
  uploads: {
    all: ['uploads'] as const,
    list: (filters?: unknown) => [...QUERY_KEYS.uploads.all, 'list', filters] as const,
    preSignedUrl: (uploadID: string) => [...QUERY_KEYS.uploads.all, 'preSignedUrl', uploadID] as const,
  },
}

export const STALE_TIME = {
  '24Hours': 86400000,
  '12Hours': 43200000,
  '6Hours': 21600000,
  '1Hour': 3600000,
}
